import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/internal/operators';
import {IKala} from '../../shared/model/kala.model';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';


type EntityResponseType = HttpResponse<IKala>;
type EntityArrayResponseType = HttpResponse<IKala[]>;

@Injectable({providedIn: 'root'})
export class KalaService {
  public resourceUrl = SERVER_API_URL + 'api/kalas';

  constructor(protected http: HttpClient) {
  }

  create(kala: IKala): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(kala);
    return this.http
      .post<IKala>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  update(kala: IKala): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(kala);
    return this.http
      .put<IKala>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http
      .get<IKala>(`${this.resourceUrl}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http
      .get<IKala[]>(this.resourceUrl, {params: options, observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  findMyKalaCount(id: number): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-self-count'}/${id}`, {observe: 'response'});
  }

  findMyKala(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<IKala[]>(`${this.resourceUrl + '-self'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  findKalaTransaction(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<IKala[]>(`${this.resourceUrl + '-transaction'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }
  findWithCustomerId(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<IKala[]>(`${this.resourceUrl + '-customer'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  protected convertDateFromClient(kala: IKala): IKala {
    const copy: IKala = Object.assign({}, kala, {
    });
    return copy;
  }

  protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
      // res.body.expiratioDate = res.body.expiratioDate != null ? moment(res.body.expiratioDate) : null;
    }
    return res;
  }

  protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
    if (res.body) {
      res.body.forEach((kala: IKala) => {
      });
    }
    return res;
  }
}
